const updateAccountButton = (loginButton) => {
    if(loginButton){
        const newText = loginButton.dataset.loggedInText;
        if(newText){

            if(loginButton.classList.contains("skio-account-login-button-container")){
                const wavyButton = loginButton.querySelector(".wavy-button");
                const wavyButtonText = wavyButton?.querySelector("p");
                if(wavyButton && wavyButtonText){
                    wavyButton.href = "/a/account/loyalty";
                    wavyButtonText.textContent = newText;
                }else{

                    const ribbonButton = loginButton.querySelector(".ribbon-button");
                    const ribbonButtonText = ribbonButton?.querySelector("p");

                    if(ribbonButton && ribbonButtonText){

                        ribbonButton.href = "/a/account/loyalty";
                        ribbonButtonText.textContent = newText;

                    }else{
                        loginButton.href = "/a/account/loyalty";
                        loginButton.textContent = newText;
                    }                    
                }

            }else{

                // Maintain the old way this was done for non-wavy buttons            
                loginButton.href = "/a/account/loyalty";
                loginButton.textContent = newText;
            }
        }
    }
}


document.addEventListener("DOMContentLoaded", function () {
    
    let checkForSkio = false;
    
    //Loyalty Landing Page /pages/the-bean-club - search for login buttons that we need to update
    const skioLoginButtons = document.querySelectorAll(".skio-account-login-button");

    //Cart and PDP tools - show Bean Tier Discount for logged in Users who have a specific tier and have access to tier discounts
    const cartLoyaltyMessageContainer = document.querySelector(".cart-modal__hero-loyalty-container");
    let pdpLoyaltyMessageContainer = false;
    
    const planPicker = document.querySelector("skio-plan-picker");
    if(planPicker){
        if(planPicker.shadowRoot){
            pdpLoyaltyMessageContainer = planPicker.shadowRoot.querySelector(".pdp-loyalty-container");
        }
    }

    const $referralExpSections = document.querySelectorAll(".section-skio-referrals-explanation");

    if(skioLoginButtons.length > 0 || cartLoyaltyMessageContainer || pdpLoyaltyMessageContainer || $referralExpSections.length > 0){
        checkForSkio = true;
    }

    let isLoggedIn = false;
    let skioSDK = false;
    if(checkForSkio){
        skioSDK = new window.SkioSDK({ domain: window.Shopify.shop, debug: false });      
        isLoggedIn = skioSDK.checkLogin();
    }

    //Initiate the Skio SDK early to prevent duplicate intialisations    
    if(cartLoyaltyMessageContainer || pdpLoyaltyMessageContainer){

        if(isLoggedIn){
            (async () => {
                try {
                    const tierInfo = await skioSDK.getSiteTierRewards();
                
                    let userTier = false;
                    let percentageValue = false;
                    
                    if(tierInfo.ok){
                        tierInfo.tierLevels.forEach((tierLevel) => {
                            if(tierLevel.name == tierInfo.userTierName){
                                tierLevel.TierRewards.forEach((tierReward) => {

                                    userTier = tierInfo.userTierName;
                                    console.log(userTier);
                                    
                                    //Find the Subscription Discount Reward - cater for the tier not having one
                                    if(tierReward.rewardData.type == "DISCOUNT" && tierReward.name.toLowerCase().indexOf("off subscriptions") !== -1){

                                        //Ensure this is a type of Discount Percentage - lets not trip ourselves over with applying a discount based message to a 
                                        if(tierReward.rewardData.rewardConfig.discountType == "PERCENTAGE"){
                                            userTier = tierInfo.userTierName;
                                            percentageValue = tierReward.rewardData.rewardConfig.discountValue;
                                        }                                        
                                    }
                                });
                            }
                        });
                        
                        if(userTier && percentageValue){
                            
                            const tierToken = "[[tier_name]]";
                            const percentageToken = "[[percentage_value]]";

                            //Replace the content in Cart and PDP with the necessary text
                            if(cartLoyaltyMessageContainer){
                                
                                const messageText = cartLoyaltyMessageContainer.querySelector(".cart-modal__hero-loyalty-message-text");
                                if(messageText){
                                    messageText.textContent = messageText.textContent.replace(tierToken,userTier);
                                }

                                const percentageText = cartLoyaltyMessageContainer.querySelector(".cart-modal__hero-loyalty-message-percentage");
                                if(percentageText){
                                    percentageText.textContent = percentageText.textContent.replace(percentageToken,percentageValue);
                                }
                                
                                cartLoyaltyMessageContainer.style.display = "flex";
                            }

                            if(pdpLoyaltyMessageContainer){

                                const messageText = pdpLoyaltyMessageContainer.querySelector(".pdp-loyalty-message-text");
                                if(messageText){
                                    messageText.textContent = messageText.textContent.replace(tierToken,userTier);
                                }
                                
                                const percentageText = pdpLoyaltyMessageContainer.querySelector(".pdp-loyalty-message-percentage");
                                if(percentageText){
                                    percentageText.textContent = percentageText.textContent.replace(percentageToken,percentageValue);
                                }
                                
                                pdpLoyaltyMessageContainer.style.display = "flex";
                            }
                        }
                    }else{
                        console.log("tierInfo.ok was in fact, not ok");
                    }                
                } catch (error) {
                    console.error('Failed to get tier rewards:', error);
                }
            })();
        }
    }

    //Update account related buttons when the user is logged into Skio already
    if(skioLoginButtons.length > 0){
        if(isLoggedIn){
            skioLoginButtons.forEach((loginButton) => {
                updateAccountButton(loginButton);
            });
        }
    }

    //Subscribe and Save page - manage subscriptions button hidden unless logged in
    const skioManageSubscriptionButtons = document.querySelectorAll(".skio-manage-subscriptions-button");
    if(skioManageSubscriptionButtons.length > 0){
        skioManageSubscriptionButtons.forEach((skioManageSubscriptionButton) => {
            if(isLoggedIn){
                skioManageSubscriptionButton.classList.remove("hidden");
            }
        });
    }

    // Hide section-skio-referrals-explanation sections if logged in
    if(isLoggedIn){
        let skioAppBlockHeading = "";
        $referralExpSections.forEach(($referralExpSection) => {
            $referralExpSection.classList.add("tribe-hidden");
            if(skioAppBlockHeading == ""){
                skioAppBlockHeading = $referralExpSection.dataset.skioAppBlockHeading;
            }
        });

        // While we're here, attempt to override the heading on the Skio App Block
        const $skioAppBlock = document.querySelector(".skio-rp");
        if($skioAppBlock){
            const $heading = $skioAppBlock.querySelector(".content-section .main-heading");
            if($heading){
                $heading.textContent = skioAppBlockHeading;
            }
        }
    }

});